<template>
    <div :class="{ 'ly-is-full': isFull }">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="代理商名称：">
                    <el-input v-model.trim="formInline.name" maxlength="60" clearable placeholder="代理商名称" @change="search"
                        style="width:130px"></el-input>
                </el-form-item>
                <el-form-item label="负责人电话：">
                    <el-input v-model.trim="formInline.mobile" maxlength="60" clearable placeholder="负责人电话" @change="search"
                        style="width:130px"></el-input>
                </el-form-item>
                <!-- <el-form-item label="开通地区：">
                    <el-input v-model.trim="formInline.cityname" maxlength="60" clearable placeholder="开通地区"
                        @change="search" style="width:130px"></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="状态：">
                    <el-select size="default" v-model="formInline.is_active" placeholder="请选择" clearable style="width: 90px"
                        @change="search">
                        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="时间：">
                    <el-date-picker style="width:350px" v-model="timers" type="datetimerange" @change="timeChange"
                        range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item> -->
                <el-form-item label=""><el-button @click="search" type="primary" icon="Search"
                        v-show="hasPermission(this.$route.name, 'Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="handleEdit('', 'reset')"
                        icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button @click="handelAddClick" type="primary" icon="Plus"
                        v-show="hasPermission(this.$route.name, 'Create')">新增</el-button></el-form-item>
            </el-form>
        </div>

        <div class="table">
            <el-table :height="tableHeight" border :data="tableData" ref="tableref" v-loading="loadingPage">
                <!-- <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column> -->
                <el-table-column width="100" prop="id" label="代理商编号"></el-table-column>
                <el-table-column min-width="110" prop="name" label="代理商名称"></el-table-column>
                <el-table-column min-width="150" label="地址" show-overflow-tooltip>
                    <template #default="scope">
                        {{ scope.row.userinfo.areaname + scope.row.userinfo.place }}
                    </template>
                </el-table-column>
                <el-table-column width="100" prop="balance" label="卡点" show-overflow-tooltip></el-table-column>
                <el-table-column width="110" prop="userinfo.leader_name" label="负责人姓名"></el-table-column>
                <el-table-column width="120" prop="userinfo.leader_mobile" label="负责人电话"></el-table-column>
                <el-table-column width="90" prop="userinfo.business_license" label="营业执照">
                    <template #default="scope">
                        <el-image :src=scope.row.userinfo.business_license
                            :preview-src-list="[scope.row.userinfo.business_license]" preview-teleported
                            style="width: 45px;height: 45px"></el-image>
                    </template>
                </el-table-column>
                <el-table-column width="150" prop="username" label="账号"></el-table-column>
                <el-table-column width="170" prop="create_datetime" label="创建时间"></el-table-column>
                <el-table-column width="90" label="状态">
                    <template #default="scope">
                        <el-switch v-model="scope.row.is_active" active-color="#13ce66" inactive-color="#ff4949"
                            @change="changeStatus(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="180">
                    <template #header>
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>操作</div>
                            <div @click="setFull">
                                <el-tooltip content="全屏" placement="bottom">
                                    <el-icon><full-screen /></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                    <template #default="scope">
                        <span class="table-operate-btn" @click="handleEdit(scope.row, 'detail')">详情</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row, 'edit')"
                            v-show="hasPermission(this.$route.name, 'Update')">编辑</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row, 'recharge')"
                            v-show="hasPermission(this.$route.name, 'Recharge')">充值卡点</span>
                        <!-- <span class="table-operate-btn" @click="handleEdit(scope.row, 'delete')"
                            v-show="hasPermission(this.$route.name, 'Delete')">删除</span> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <addUser ref="addUserFlag" @refreshData="getData" v-if="isDialogVisible" @closed="isDialogVisible = false">
        </addUser>
        <AddModule ref="addModuleFlag" @refreshData="getData" v-if="isDialogRechargeVisible"
            @closed="isDialogRechargeVisible = false"></AddModule>
    </div>
</template>
<script>
import addUser from "./components/addUserAgent";
import AddModule from "./components/addModuleAgentRecharge";
import Pagination from "@/components/Pagination";
import { dateFormats, getTableHeight } from "@/utils/util";
import { UsersAgentUsers, UsersAgentUsersDelete, UsersAgentUsersDisable } from '@/api/api'
export default {
    components: {
        Pagination,
        addUser,
        AddModule
    },
    name: 'agentUserManage',
    data() {
        return {
            isFull: false,
            tableHeight: 500,
            loadingPage: false,
            formInline: {
                page: 1,
                limit: 10,
            },
            defaultImg: require('../../assets/img/avatar.jpg'),
            pageparm: {
                page: 1,
                limit: 10,
                total: 0
            },
            statusList: [
                { id: 1, name: '正常' },
                { id: 0, name: '禁用' }
            ],
            identityList: [
                { id: 0, name: '普通用户' },
                { id: 1, name: '会员' },
            ],
            timers: [],
            tableData: [],
            isDialogVisible: false,
            isDialogRechargeVisible: false,
        }
    },

    methods: {
        // 表格序列号
        getIndex($index) {
            // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
            return (this.pageparm.page - 1) * this.pageparm.limit + $index + 1
        },
        setFull() {
            this.isFull = !this.isFull
            window.dispatchEvent(new Event('resize'))
        },
        changeStatus(row) {
            let vm = this
            let flat = row.is_active
            row.is_active = !row.is_active
            let temp_is_allow = 1
            vm.$confirm('确定修改状态吗？', '提醒', {
                closeOnClickModal: false,
                type: "warning"
            }).then(res => {
                flat ? row.is_active = true : row.is_active = false
                if (row.is_active) {
                    temp_is_allow = 1
                } else {
                    temp_is_allow = 0
                }
                UsersAgentUsersDisable({ id: row.id }).then(res => {
                    if (res.code == 2000) {
                        vm.$message.success(res.msg)
                        vm.getData()
                    } else {
                        vm.$message.warning(res.msg)
                    }
                })
            }).catch(() => {

            })
        },
        handelAddClick() {
            this.isDialogVisible = true
            this.$nextTick(() => {
                this.$refs.addUserFlag.handleOpen(null, "新增")
            })
        },
        handleEdit(row, flag) {
            if (flag == 'edit') {
                this.isDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.addUserFlag.handleOpen(row, "编辑")
                })
            }
            else if (flag == 'detail') {
                this.isDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.addUserFlag.handleOpen(row, "详情")
                })
            } else if (flag == 'recharge') {
                this.isDialogRechargeVisible = true
                this.$nextTick(() => {
                    this.$refs.addModuleFlag.handleOpen(row, "充值卡点")
                })
            }
            else if (flag == 'disable') {
                let vm = this
                UsersAgentUsersDisable({ id: row.id }).then(res => {
                    if (res.code == 2000) {
                        vm.$message.success(res.msg)
                        vm.search()
                    } else {
                        vm.$message.warning(res.msg)
                    }
                })
            }
            else if (flag == 'delete') {
                let vm = this
                vm.$confirm('您确定要删除选中的数据吗？', {
                    closeOnClickModal: false
                }).then(res => {
                    UsersAgentUsersDelete({ id: row.id }).then(res => {
                        if (res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.search()
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }).catch(() => {

                })
            }
            else if (flag == "reset") {
                this.formInline = {
                    page: 1,
                    limit: 10
                }
                this.pageparm = {
                    page: 1,
                    limit: 10,
                    total: 0
                }
                this.getData()
            }
        },
        /**
         * 从URL里下载文件
        */
        // 下载文件
        downloadFileURL(url) {
            var iframe = document.createElement("iframe")
            iframe.style.display = "none";
            iframe.src = url;
            document.body.appendChild(iframe);
        },
        exportDataBackend() {
            var params = {
                page: 1,
                limit: 9999,
            }
            // UsersUsersExportexecl(params).then(res => {
            //     if (res.code == 2000) {
            //         this.downloadFileURL(res.data.data)
            //         //this.$message.warning(res.data.data)
            //     }
            // })
        },
        callFather(parm) {
            this.formInline.page = parm.page
            this.formInline.limit = parm.limit
            this.getData()
        },
        search() {
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getData()
        },
        //获取列表
        async getData() {
            this.loadingPage = true
            UsersAgentUsers(this.formInline).then(res => {
                this.loadingPage = false
                if (res.code == 2000) {
                    this.tableData = res.data.data
                    this.pageparm.page = res.data.page;
                    this.pageparm.limit = res.data.limit;
                    this.pageparm.total = res.data.total;
                }
            })
        },

        timeChange(val) {
            if (val) {
                this.formInline.beginAt = dateFormats(val[0], 'yyyy-MM-dd hh:mm:ss');
                this.formInline.endAt = dateFormats(val[1], 'yyyy-MM-dd hh:mm:ss');
            } else {
                this.formInline.beginAt = null
                this.formInline.endAt = null
            }
            this.search()
        },
        // 计算搜索栏的高度
        listenResize() {
            this.$nextTick(() => {
                this.getTheTableHeight()
            })
        },
        getTheTableHeight() {
            let tabSelectHeight = this.$refs.tableSelect ? this.$refs.tableSelect.offsetHeight : 0
            tabSelectHeight = this.isFull ? tabSelectHeight - 110 : tabSelectHeight
            this.tableHeight = getTableHeight(tabSelectHeight)
        }

    },
    created() {
        this.getData()
    },
    mounted() {
        // 监听页面宽度变化搜索框的高度
        window.addEventListener('resize', this.listenResize);
        this.$nextTick(() => {
            this.getTheTableHeight()
        })
    },

    unmounted() {
        // 页面销毁，去掉监听事件
        window.removeEventListener("resize", this.listenResize);
    },
}
</script>
